import { default as deserialize } from 'app/utils/deserialize'
import { fetch } from 'app/utils/data'

export default {
  namespaced: true,

  state: {
    list: []
  },

  getters: {
    pageviewDomains: (state) => state.list
  },

  mutations: {
    pageviewDomainsFetched(state, { pageviewDomains }) {
      state.list = pageviewDomains
    }
  },

  actions: {
    async fetchPageviewDomains({ commit }, id) {
      const response = await fetch({
        url: '/api/admin/kits/pageview-domains',
        params: {
          id: id
        }
      })

      const pageviewDomains = await deserialize(response.data)

      commit('pageviewDomainsFetched', { pageviewDomains })
    }
  }
}
